import {
  makeRequired,
  passwordValidator,
} from '../../../../../OUI/Inputs';

export const passwordFieldValidator = makeRequired(passwordValidator);
